<crm-single-select
  #singleSelectComponent
  [options]="scenarios"
  [(selectedItem)]="_selectedScenario"
  (selectedItemChange)="onSelect($event)"
  [label]="labelInput ? 'Сценарий планирования' : ''"
  [class]="class + (isError ? ' ng-invalid ng-dirty' : '')"
  [styleClass]="styleClass + (isError ? ' ng-invalid ng-dirty' : '')"
  [virtualScroll]="true"
  [virtualScrollItemSize]="35"
  (onShow)="onShowPanel()"
  (onFilter)="search($event.filter)"
  [disabled]="disabled"
  [showClear]="showClear"
  [placeholder]="placeholder"
  [appendTo]="appendTo"
  [loading]="loading || selectionLoading">
  <ng-template #footerTemplate>
    <crm-spinner
      *ngIf="paginationLoading"
      top=""
      text=""
      [height]="35"
      [width]="35"
      bottom=""></crm-spinner>
  </ng-template>
</crm-single-select>
